export const removeFalsyProperties = (object: Record<string, unknown>) => {
  const newObject = {};
  Object.keys(object).forEach((key) => {
    if (object[key]) {
      newObject[key] = object[key];
    }
  });
  return newObject;
};
